import { TopBarThemedThemeSizeConfig } from './types';

const medium: TopBarThemedThemeSizeConfig = {
  topBarThemed: {},
};

export default medium;
